const stats = [
  { value: '1992', label: 'Gegründet' },
  { value: '30+', label: 'Jahre Erfahrung' },
  { value: '500+', label: 'Projekte realisiert' },
  { value: '7', label: 'Leistungsbereiche' },
];

const ServiceHero = () => {
  return (
    <section className="relative pt-32 pb-24 bg-[#0f1f4a] overflow-hidden min-h-[520px] flex items-center">
      {/* Background image from gowitec.de */}
      <div className="absolute inset-0">
        <img
          src="/images/oben1.jpg"
          alt="gowiTEC Leistungen – Maschinenbau und Automatisierung"
          className="w-full h-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        {/* Dark gradient overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f1f4a] via-[#0f1f4a]/90 to-[#0f1f4a]/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-0.5 bg-[#DC2626]"></span>
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Unsere Expertise</span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
            Maßgeschneiderte Lösungen für Ihre Automatisierung
          </h1>
          <p className="text-blue-200 text-base md:text-lg leading-relaxed mb-10">
            Von der Konzeption bis zur Inbetriebnahme – gowiTEC realisiert komplexe Automatisierungsprojekte mit über 30 Jahren Erfahrung und technischer Präzision.
          </p>

          {/* Stats row */}
          <div className="flex flex-wrap gap-10">
            {stats.map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="text-3xl font-bold text-white leading-none">{stat.value}</span>
                <span className="text-blue-300 text-sm mt-1">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
